import { getPartsFromUrl, veridLoginUI } from 'csa-shared-lib';
import { OrgAuthConfigType, Role } from '../lib/verid-api/verid-api-types';
import decode from 'jwt-decode';
import { ClientLogger } from '../lib/client-logger';

const DEBUG = true;

interface AttribFromURL {
  orgId: string | null;
  role: Role | null;
  orgAuthId: string | null;
}
export interface JsonWebToken {
  exp: number;
  sub: string | undefined; // unique user Id
  authConfigType?: OrgAuthConfigType;
}

const BASE_DOMAIN = 'healix.cmsmastercloud.ca';
const tokenHolderSingleton: { token: string | undefined; jwt: JsonWebToken | undefined } = {
  token: undefined,
  jwt: undefined,
};

const veridTokenHolderSingleton: { token: string | undefined; jwt: JsonWebToken | undefined } = {
  token: undefined,
  jwt: undefined,
};

export function getTokenHolder(): { token: string | undefined; jwt: JsonWebToken | undefined } {
  if (veridLoginUI) {
    return veridTokenHolderSingleton;
  } else {
    return tokenHolderSingleton;
  }
}

export const setTokenHolder = (token: string | undefined, jwt?: JsonWebToken | undefined) => {
  if (veridLoginUI) {
    veridTokenHolderSingleton.token = token;
    veridTokenHolderSingleton.jwt = jwt || (token ? (decode(token) as JsonWebToken) : undefined);
  } else {
    tokenHolderSingleton.token = token;
    tokenHolderSingleton.jwt = jwt || (token ? (decode(token) as JsonWebToken) : undefined);
  }
  DEBUG && console.debug('setTokenHolder', { token, jwt, veridTokenHolderSingleton, tokenHolderSingleton });
  window.localStorage['formioToken'] = token;
};

const STORAGE_KEY = 'org-auth-lib-role-orgId';

export function writeRoleAndIdToStorage(attribs: AttribFromURL): AttribFromURL {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(attribs));
  } catch (e) {
    console.error('Error writing orgId and role to storage:', e);
  }
  return attribs;
}

export function getRoleAndIdFromURLOrStorage(): AttribFromURL {
  // first check local storage
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (parsed && parsed.orgId && parsed.role) {
        DEBUG && ClientLogger.debug('getRoleAndIdFromURLOrStorage', 'Using stored orgId and role', parsed);
        return parsed;
      }
    } catch (e) {
      ClientLogger.error('getRoleAndIdFromURLOrStorage', 'Error parsing stored orgId and role:', e);
    }
  }
  const { useQueryStringForOrgAndRole, orgId, role, queryParams } = getPartsFromUrl(window.location.href);
  DEBUG &&
    ClientLogger.debug('getRoleAndIdFromURLOrStorage', 'Parsed URL parts', { useQueryStringForOrgAndRole, orgId, role, queryParams });
  const urlParams = new URLSearchParams(window.location.search);
  const orgAuthId = urlParams.get('cid') || null;

  // if isLocalDev, then we pick up the orgId and role from the URL params, otherwise they are part of the base URL
  if (useQueryStringForOrgAndRole) {
    return writeRoleAndIdToStorage({
      orgId: orgId || null,
      role: role || null,
      orgAuthId,
    });
  }

  // sanity check base domain and parts
  if (!orgId || !role) {
    ClientLogger.error('getRoleAndIdFromURLOrStorage', 'Invalid URL format. Expected format: https://role.orgId.' + BASE_DOMAIN);
    return { orgId: null, role: null, orgAuthId };
  }

  return writeRoleAndIdToStorage({ orgId, role: role as Role | null, orgAuthId });
}
